import { render, staticRenderFns } from "./CanvasMark.vue?vue&type=template&id=4881feee&scoped=true"
import script from "./CanvasMark.vue?vue&type=script&lang=js"
export * from "./CanvasMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881feee",
  null
  
)

export default component.exports